export var useUser = function () {
    var userKey = 'user';
    var setUserStorage = function (user) {
        localStorage.setItem(userKey, JSON.stringify(user));
    };
    var getUserStorage = function () {
        var user = localStorage.getItem(userKey);
        if (!user)
            return false;
        return JSON.parse(user);
    };
    var removeUserStorage = function () {
        localStorage.removeItem(userKey);
    };
    var isDone = function (key) {
        var user = getUserStorage();
        if (!user)
            return false;
        return user.progress.keys.includes(key);
    };
    var progressPercentage = function () {
        var user = getUserStorage();
        if (!user)
            return 0;
        return user.progress.percentage;
    };
    return {
        userKey: userKey,
        setUserStorage: setUserStorage,
        getUserStorage: getUserStorage,
        removeUserStorage: removeUserStorage,
        isDone: isDone,
        progressPercentage: progressPercentage,
    };
};
